import { AfterViewChecked, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';

declare let window: any;


/**
 * Componente para el mensaje de confirmación de cookis
 */
@Component({
  standalone: false,
  selector: 'app-modal-cookies',
  templateUrl: './modal-cookies.component.html',
  styleUrls: ['./modal-cookies.component.scss']
})
export class ModalCookiesComponent implements OnInit, AfterViewChecked {

  /**
   * Crea una instancia para modal cookies component.
   * @param r 
   * @param c 
   */
  constructor(private readonly r: Router, private c: CommonsService) { }

  /**
   * on init - crea el modal desde la librería
   */
  ngOnInit() {
    this.c.reloadOTBanner();
    this.c.clearDup();
  }

  /**
   * after view checked
   */
  ngAfterViewChecked() {
  }

  /**
   * Redirige a la url especificada
   * @param url 
   */
  goToUrl(url) {
    this.r.navigateByUrl(url);
  }

  OptanonWrapper() {
    this.c.getBanner();
    window.dataLayer.push({ event: 'OneTrustGroupsUpdated' });
  }
}
